import {
  Box,
  Container,
  Flex,
  Heading,
  Text,
} from '@chakra-ui/react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';
import { ArrowForwardIcon } from '@chakra-ui/icons';

import { GiMoneyStack } from 'react-icons/gi';
import { IoDocumentTextOutline } from 'react-icons/io5';
import { IoIosRocket } from 'react-icons/io';
import React from 'react';
import { generate } from 'shortid';
import House2 from '../../assets/houses/house-02.svg';
import FlareGroup2 from '../../assets/shapes/shape-group-2.svg';
import {
  CalloutPhoneNumber,
  LinkPhone,
  LinkOne,
  HalfByHalfSection,
} from '../_index';

const howItWorks = [
  {
    header: 'Start A Conversation',
    icon: <IoDocumentTextOutline />,
    content:
      'Give us a call or fill out our offer form. start writing up a lucrative offer. ',
  },
  // {
  //   header: 'Quick Walk Through',
  //   icon: <IoDocumentTextOutline />,
  //   content:
  //     'We immediately schedule a walk through to prepare our offer.',
  // },
  {
    header: 'Receive Your Cash Offer',
    icon: <GiMoneyStack />,
    content:
      'After our assessment of your property you receive a cash offer for your review with no obligation to accept.',
  },
  {
    header: 'Cash Your Check',
    icon: <IoIosRocket />,
    content:
      "Cash your check, pick a move date, take what you want, leave what you don't, no worries, no cleaning, no repair.",
  },
];

const HowItWorksCards = ({ data }) => (
  <Box>
    <Box
      display="flex"
      pt={10}
      justifyContent="space-around"
      flexWrap="wrap"
    >
      {data.map((d, i) => (
        <Box
          mx={{ sm: 'auto', md: '2' }}
          key={generate()}
          flexBasis={{ base: '40%', md: '30%' }}
          mb={10}
          position="relative"
          // background="brand.five"
          border="2px"
          borderColor="gray.700"
          rounded="md"
          zIndex="1"
        >
          <Box p={{ base: 3, md: 5 }}>
            <Box
              display="flex"
              flexDir="column"
              alignItems="center"
              justifyContent="space-between"
              className="mwidth-300"
              position="relative"
            >
              <Box
                width="70px"
                height="70px"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box
                  color="gray.700"
                  opacity=".6"
                  fontSize="5rem"
                >
                  {d.icon}
                </Box>
              </Box>

              <Box
                top="-100px"
                position="absolute"
                right="0%"
              >
                <Heading
                  fontSize="9rem"
                  textAlign="center"
                  opacity=".4"
                  variant="sec"
                >
                  {i + 1}
                </Heading>
              </Box>
              {/* <Box
                    width="70px"
                    height="70px"
                    border="2px"
                    padding={4}
                    borderColor="gray.700"
                    borderRadius="full"
                  >

                    <Box>{d.icon}</Box>
                  </Box> */}
              <Heading
                as="h5"
                size="xl"
                my={4}
              >
                {d.header}
              </Heading>
              <Text fontSize="xl">{d.content}</Text>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
);

const LeftBlock = () => (
  <>
    <Heading
      zIndex="1"
      as="h4"
      size="3xl"
    >
      How it Works?
    </Heading>
    <Heading
      as="h5"
      size="lg"
      variant="sec"
    >
      Upfront, fair, seamless, and most important
      {' '}
      <span className="highlight">stress free</span>
    </Heading>
    <Box mt={6}>
      <LinkOne
        mb={4}
        to="/how-it-works/"
        icon={<ArrowForwardIcon />}
      >
        More On How It Works
      </LinkOne>
      <LinkOne
        mb={4}
        to="/how-it-works/#example"
        icon={<ArrowForwardIcon />}
      >
        See A Real World Example
      </LinkOne>
    </Box>
  </>
);

const RightBlock = () => (
  <Box
    zIndex="0"
    className="height-200"
  >
    <Box
      position="relative"
      width="20rem"
      mx="auto"
      transform={{ base: 'scale(.7)', md: 'scale(1)' }}
    >
      <Box
        position="absolute"
        opacity={0.8}
        zIndex="1"
        top="-20%"
        left="-5%"
      >
        <House2 className="width-200 height-300 flip-x" />
      </Box>
      <Box
        position="absolute"
        opacity={0.5}
        top="0%"
        left="-20%"
      >
        <FlareGroup2 className="width-500 height-400 flip-x" />
      </Box>
    </Box>
  </Box>
);

const HowItWorks = ({ data = howItWorks }) => {
  const { headerImage, flareImage } = useStaticQuery(query);

  const headerImg = getImage(headerImage);
  const flare = getImage(flareImage);

  return (
    <>
      <Box py={20}>
        <Container maxW="container.xl">
          <HalfByHalfSection
            pb={{ base: 4, md: 10 }}
            left={<LeftBlock />}
            right={<RightBlock />}
          />

          <HowItWorksCards data={data} />
          <CalloutPhoneNumber />
        </Container>
      </Box>
    </>
  );
};

export const query = graphql`
  query {
    guaranteedImg: file(
      relativePath: { eq: "satisfaction-guaranteed.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 500, placeholder: BLURRED)
      }
    }
    eugeneProfile: file(relativePath: { eq: "team/profile.png" }) {
      childImageSharp {
        gatsbyImageData(width: 400, placeholder: BLURRED)
      }
    }
    headerImage: file(
      relativePath: { eq: "illustrations/social-2.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 600, placeholder: BLURRED)
      }
    }
    flareImage: file(
      relativePath: { eq: "illustrations/ellipse-5.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
  }
`;

export default HowItWorks;
